module.exports = __webpack_public_path__ + "media/student_v2/assets/images/alert_icon-02aa22e116c6a256a3ccc5b67093ef7c.svg";